import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-panel-h1-a1-ma1-md0',
    templateUrl: './panel-h1-a1-ma1-md0.component.html',
    styleUrls: [
        '../panels.scss',
        './panel-h1-a1-ma1-md0.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PanelH1A1MA1MD0Component implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
